import { render, staticRenderFns } from "./customersth.vue?vue&type=template&id=284943dc&scoped=true&"
import script from "./customersth.vue?vue&type=script&lang=js&"
export * from "./customersth.vue?vue&type=script&lang=js&"
import style0 from "./customersth.vue?vue&type=style&index=0&id=284943dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284943dc",
  null
  
)

export default component.exports